import { Router } from '@angular/router';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BoardsService } from '@app-services/boarrds/boards.service';
import { UserService } from '@app-services/user/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { allowedExamNamesCT, apisDataCacheKeys } from '@app-constants/app.constants';
import { TestlistService } from '@app-services/test/testlist.service';

@Component({
  selector: 'app-focus-exam',
  templateUrl: './focus-exam.component.html',
  styleUrls: ['./focus-exam.component.css']
})
export class FocusExamComponent implements OnInit {
  // data: any;
  exams: any = [];
  searchIndices: any = [];
  exams1: any = [];
  allSearchIndices: any = [];
  hignlightExam: number;
  selectedExams: any = {};
  personalDetailsChanged: boolean = false;
  currentData: any;
  constructor(
    private targetExamService: BoardsService,
    private userService: UserService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<FocusExamComponent>,
    private router: Router,
    private gaService: GAnalyticsService,
    private testListService: TestlistService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.currentData = JSON.parse(localStorage.getItem("user_details_from_server"));
    const userGrade = this.currentData?.grade?.name?.replace(/[^0-9]/g, '');
    this.exams = this.currentData?.exams
      .sort((a, b) => allowedExamNamesCT[userGrade]?.indexOf(a?.name?.replace(/[^a-z]/ig, '').toUpperCase())<allowedExamNamesCT[userGrade]?.indexOf(b?.name?.replace(/[^a-z]/ig, '').toUpperCase()) ? -1 : 1);
      this.hignlightExam = this.exams.findIndex(ele => ele.name.replace(' ', '').toLowerCase() === this.data?.msg.replace(' ', '').toLowerCase());
    this.selectExam(this.hignlightExam);
     }

  close() {
    this.dialogRef.close();
  }

  selectExam(exam: any) {
    this.hignlightExam = exam;
    this.selectedExams = this.exams[exam];
    localStorage.setItem("selectedExam", JSON.stringify(this.selectedExams))
  }

  onClickConfirm() {
    this.gaService.webEngageEvent({
      'event': 'Current Grade_Exam',
      'exam_name': this.selectedExams?.name,
      'grade': this.currentData?.grade?.gradeId
    })
    this.dialogRef.close(this.selectedExams);
    this.udate(this.selectedExams);
    window.location.reload();
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  editPreference() {
    let data = {
      exams: this.exams,
      grade: this.currentData?.grade,
      isGradeEdit: false
    }
    localStorage.setItem('grade-stream-board-data', JSON.stringify(data));
    this.dialogRef.close();
    this.router.navigate(['myprofile/target-exam'])
  }

  udate(selectedExams : any){
    localStorage.setItem("targetExamName", this.currentData?.selectedExams[0]?.name?.replaceAll(" ", "")?.toUpperCase());
    const currentData = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
    const obj = currentData;
    obj.selectedExams = [selectedExams];
    console.log(obj)
    const userGrade = this.currentData?.grade?.name?.replace(/[^0-9]/g, '');
    this.userService.updateUserDetails(obj).subscribe((data: any) => {
    })
  }
}
